import axios, { AxiosResponse, CancelToken } from 'axios';
import environment from '../environment/environment';
import { UserService } from './user.service';

export class EFileAnalyzerService {
	private baseUrl = environment.apiGateway.apiUrl;
	private apiURL = '';

	constructor() {
		this.apiURL = this.baseUrl + 'EFileAnalyzer';
	}

	/**
	 *  get user own record
	 */
	public async sendEFileAnalyzeRequest(data: any, cancelToken?: CancelToken): Promise<AxiosResponse<Blob>> {
		try {
			const url = this.apiURL + '/Analyze';
			const res = await axios.post<Blob>(url, data, {
				cancelToken,
				responseType: 'blob',
				headers: {
					Authorization: "Bearer " + UserService.GetAuthMSAuthorizationToken()
				}
			});
			return res;
		} catch (error) {
			throw error;
		}
	}
}
